const AMPLIFY_CONFIG = {
  Auth: {
    identityPoolId: process.env.VUE_APP_AMPLIFY_IDENTITY_POOL_ID,
    region: process.env.VUE_APP_AMPLIFY_REGION,
    userPoolId: process.env.VUE_APP_AMPLIFY_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
    mandatorySignIn: true,
    authenticationFlowType: 'USER_SRP_AUTH',
  },
};

export { AMPLIFY_CONFIG };
